import { CircularProgress, Stack } from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useConfig } from "../containers/ConfigContext";
import { ChartTypeEnum } from "../models/company.model";
import CustomizedBar from "../components/Charts/CustomizedBar";
import CustomizedDoughnut from "../components/Charts/CustomizedDoughnut";
import CustomizedLine from "../components/Charts/CustomizedLine";
import CustomizedMixed from "../components/Charts/CustomizedMixed";
import TopHeader from "../components/TopHeader";
import CustomizedTable from "../components/Charts/CustomizedTable";

export default function ChartsPrintPage() {
  const navigate = useNavigate();
  const { url } = useParams();
  const { loggedUser } = useConfig();
  const page = loggedUser?.chartConfig?.pages?.find((p) => p.url === url);
  const spacing = 16;
  const { data } = useConfig();

  useEffect(() => {
    const handleAfterPrint = () => {
      navigate(`/charts/${url}`);
    };

    const printTimeout = setTimeout(() => {
      window.print();
    }, 5000);

    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      clearTimeout(printTimeout);
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, [navigate, url]);

  return (
    <div>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        sx={{
          "@media print": {
            display: "none",
          },
        }}
      >
        <CircularProgress />
      </Stack>
      <div
        style={{
          width: "210mm",
          height: "297mm",
          margin: "0 auto",
          paddingRight: spacing,
          boxSizing: "border-box",
        }}
        className="chart-print-page"
      >
        {/* @ts-ignore */}
        <TopHeader print />
        {page && (
          <div style={{ width: "100%", display: "block", clear: "both" }}>
            {page.charts.map((chart, i) => (
              <div
                key={`${chart.type}-${i}`}
                style={{
                  float: "left",
                  width: chart.width <= 6 ? "50%" : "100%",
                  paddingLeft: spacing,
                  paddingTop: spacing,
                  boxSizing: "border-box",
                }}
                className="chart"
              >
                {chart.type === ChartTypeEnum.Doughnut && (
                  <CustomizedDoughnut chart={chart} reports={data} />
                )}
                {chart.type === ChartTypeEnum.Bar && (
                  <CustomizedBar chart={chart} reports={data} />
                )}
                {chart.type === ChartTypeEnum.Line && (
                  <CustomizedLine chart={chart} reports={data} />
                )}
                {chart.type === ChartTypeEnum.Mixed && (
                  <CustomizedMixed chart={chart} reports={data} />
                )}
                {chart.type === ChartTypeEnum.Table && (
                  <CustomizedTable chart={chart} reports={data} />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
